import Navbar from './Navbars';
import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Button } from 'react-bootstrap';

export default function AddToCart() {
  
  const [cartItems, setCartItems] = useState([]);

  const handleDelete = (index) =>{
    const updatedCart = [...cartItems];
    updatedCart.splice(index, 1);
    setCartItems(updatedCart);
    localStorage.setItem("cart", JSON.stringify(updatedCart));
}

  useEffect(()=>{
    const storedCart = JSON.parse(localStorage.getItem("cart")) || [];
    setCartItems(storedCart);
  }, []);

  

  return (
    <div>
      <Navbar />
      <Row className="mt-4">
            {cartItems.map((item, index) => (
              <Col key={index} xs={12} sm={6} md={4} lg={3} className="mb-4">
                <Card style={{ width: '18rem' }}>
                  <Card.Img variant="top" src={item.image} height={200} style={{ objectFit: 'contain' }} />
                  <Card.Body>
                    <Card.Title>{item.title}</Card.Title>
                    <h5>${item.price}</h5>
                    <Card.Text>{item.description}</Card.Text>
                    <Button variant="primary" onClick={() => handleDelete(item, index)}>Delete from Cart</Button>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
    </div>
  );
}
